/* eslint-disable max-len */
import React, { useEffect, useState, MouseEvent } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';
import { CloseFullIcon, QuestionIcon } from '@/styled/icon';
import './scss/index.scss';
import HomeQuestion from './component/home-question';
import moQuestion, { questionInit } from './store';
import OneQuestion from './component/one-question';
import TwoQuestion from './component/two-question';
import ThreeQuestion from './component/three-question';
import FourQuestion from './component/four-question';
import FiveQuestion from './component/five-question';
import SixQuestion from './component/six-question';
import SevenQuestion from './component/seven-question';
import EightQuestion from './component/eight-question';
import NineQuestion from './component/nine-question';
import TenQuestion from './component/ten-question';
import ElevenQuestion from './component/eleven-question';
import TwelveQuestion from './component/twelve-question';
import ThirteenQuestion from './component/thirteen-question';
import FifteenQuestion from './component/fifteen-question';
import FourteenQuestion from './component/fourteen-question';
import moUser, { getBaseInfo } from '@/store/user';
import { toggleLogin } from '@/store/login';
import { observer } from 'mobx-react';

const DButton = styled(Button)(() => ({}));

const Question = (props: any) => {
  const { activeNum } = moQuestion;
  const [question, setquestion] = useState(false);

  const Over = () => {
    document.body.style.overflow = 'hidden';
  };

  const Leave = () => {
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    getBaseInfo(questionInit);
    return () => {};
  }, []);

  return (
    <section className="quertionIconWarp">
      <section className="quertionWarp">
        <section
          className="quertionIcon"
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            if (moUser.isLogin) {
              setquestion(true);
            } else {
              toggleLogin(true);
            }
          }}>
          <QuestionIcon color={Color.primary} />
          <p>问卷调查</p>
        </section>
        {question && (
          <section
            className="quertionModel"
            onMouseOver={Over}
            onMouseLeave={Leave}>
            <p className="oneTittle">
              <span>问卷调查</span>
              <b
                onClick={() => {
                  document.body.style.overflow = 'auto';
                  setquestion(false);
                }}>
                <CloseFullIcon color={Color.c87} />
              </b>
            </p>
            <p className="twoTittle">
              请抽出几分钟时间填写我们的问卷调查，并分享您的宝贵意见和建议。通过您的参与，我们将获得更加准确、有用的数据结果，从而推动研究进程并提高社会效益。在此，我们谨代表研究团队向您深表感谢！
            </p>
            <section className="answer">
              {activeNum === 0 && <HomeQuestion />}
              {activeNum === 1 && <OneQuestion />}
              {activeNum === 2 && <TwoQuestion />}
              {activeNum === 3 && <ThreeQuestion />}
              {activeNum === 4 && <FourQuestion />}
              {activeNum === 5 && <FiveQuestion />}
              {activeNum === 6 && <SixQuestion />}
              {activeNum === 7 && <SevenQuestion />}
              {activeNum === 8 && <EightQuestion />}
              {activeNum === 9 && <NineQuestion />}
              {activeNum === 10 && <TenQuestion />}
              {activeNum === 11 && <ElevenQuestion />}
              {activeNum === 12 && <TwelveQuestion />}
              {activeNum === 13 && <ThirteenQuestion />}
              {activeNum === 14 && <FourteenQuestion />}
              {activeNum === 15 && <FifteenQuestion />}
            </section>
          </section>
        )}
      </section>
    </section>
  );
};

export default observer(Question);
